import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React from 'react'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const CountryFilter = (props) => {
  const { countryFilters, setCountryFilters, countries, useInner = false } = props
  const { translate } = useTranslation()
  const capitalize = (text) => {
    const result = text?.replace(/([A-Z])/g, " $1");
    return result?.charAt(0)?.toUpperCase() + result?.slice(1);
  }

  const countryOptions = countries?.map((item) => ({
    name: capitalize(item.name),
    id: item.id
  })).sort((a, b) => {
    if (a.name < b.name) return -1
    if (a.name > b.name) return 1
    return 0
  })

  const checkboxSelectorProps = {
    setDataFilters: setCountryFilters,
    direction: 'bottomCenter',
    dataFilters: countryFilters,
    typeFilter: 'statuses',
    data: countryOptions,
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    useInner ?
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/> :
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title='Country'
        options={countryOptions}
        selectedIds={countryFilters}
        onClearFilters={() => setCountryFilters([])}
      />
    </CheckboxSelector>
  )
}
export default CountryFilter
